import al1stScience from "./al1stScienceQuizContent";
import al1stSocialStudies from "./al1stSocialStudiesQuizContent";
import al1stMath from "./al1stMathQuizContent";
import al1stOther from "./al1stOtherQuizContent";

// 2nd Grade
import al2ndScience from "./al2ndScienceQuizContent";
import al2ndSocialStudies from "./al2ndSocialStudiesQuizContent";
import al2ndMath from "./al2ndMathQuizContent";
import al2ndOther from "./al2ndOtherQuizContent";

// 3rd Grade
import al3rdScience from "./al3rdScienceQuizContent";
import al3rdSocialStudies from "./al3rdSocialStudiesQuizContent";
import al3rdMath from "./al3rdMathQuizContent";
import al3rdOther from "./al3rdOtherQuizContent";

// 4th Grade
import al4thScience from "./al4thScienceQuizContent";
import al4thSocialStudies from "./al4thSocialStudiesQuizContent";
import al4thMath from "./al4thMathQuizContent";
import al4thOther from "./al4thOtherQuizContent";

// 5th Grade
import al5thScience from "./al5thScienceQuizContent";
import al5thSocialStudies from "./al5thSocialStudiesQuizContent";
import al5thMath from "./al5thMathQuizContent";
import al5thOther from "./al5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const altopicsMapBySubject = {
  // 1st Grade
  al_1st_science: al1stScience,
  al_1st_socialstudies: al1stSocialStudies,
  al_1st_math: al1stMath,
  al_1st_other: al1stOther,

  // 2nd Grade
  al_2nd_science: al2ndScience,
  al_2nd_socialstudies: al2ndSocialStudies,
  al_2nd_math: al2ndMath,
  al_2nd_other: al2ndOther,

  // 3rd Grade
  al_3rd_science: al3rdScience,
  al_3rd_socialstudies: al3rdSocialStudies,
  al_3rd_math: al3rdMath,
  al_3rd_other: al3rdOther,

  // 4th Grade
  al_4th_science: al4thScience,
  al_4th_socialstudies: al4thSocialStudies,
  al_4th_math: al4thMath,
  al_4th_other: al4thOther,

  // 5th Grade
  al_5th_science: al5thScience,
  al_5th_socialstudies: al5thSocialStudies,
  al_5th_math: al5thMath,
  al_5th_other: al5thOther,
  // ...add the rest
};
